import { Typography } from "@mui/material";
import { generateRgb } from "./CustomPattern";
import { useFormikContext } from "formik";
import DefaultPrintLogo from "assets/svg/DefaultPrintLogo.svg";
import { invoiceInitialValues } from "store/reducers/factorReducer";
import styled from "@emotion/styled";
import { store } from "store/store";
// @ts-ignore
import Num2persian from "num2persian";
import { formatPrice } from "helpers/dataFormat";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { forwardRef } from "react";
const SignImageContainer = styled("div")(
    ({ theme, backgroundImage }: { theme: ThemeObjType; backgroundImage: string }) => ({
        width: "200px",
        height: "50px",
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: "100% 100%",
    })
);
const SignComponent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center",
    height: "100%",
    width: "100%",
    gridTemplateColumns: "50% 50%",
}));
const Logo = styled("img")(({ theme }) => ({
    width: "6rem",
    height: '4rem'
}));
const SignContainer = styled("div")(({ theme }) => ({
    display: "grid",
    height: "100px",
    gridTemplateColumns: "50% 50%",
}));
const DetailsTextItem = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
}));
const Container = styled("div")(({ theme }) => ({
    boxShadow: "-3px 4px 24px rgba(169, 175, 184, 0.25)",
    // borderRadius: theme.shape.borderRadius,
    direction: "rtl",
}));
const FactorPatternTemplate = forwardRef(
    ({ data }: { data?: any; }, ref) => {
        const factorType = data?.type;
        const formikContext = useFormikContext();
        const { values } = formikContext as { values: typeof invoiceInitialValues };
        const {
            showAccountingCode,
            logo,
            description,
            activeSumQuantity,
            activeSumDiscount, activeSumTax,
            showDate,
            invoiceHeaderColor,
            showDueDate,
            showSellerSign,
            showCustomerSign,
            showChortkeLogo,
            showTime,
            invoiceDetails,
            sign,
            customerAddressActive,
            customerTelephoneActive, cutomerBusinessNameActive,
            customerAddress,
            customerTelephone,
            cutomerBusinessName,
            businessName,
            businessNameActive, address, addressActive, telephone, telephoneActive,
            invoiceHeaderSize, invoiceBodySize, invoiceBodyColor,
            mobile, customerMobile,

        } = values;
        const business = store.getState().businessReducer.business.business
        const businessData = {
            name: business.nickName,
            address: `${business.state ? business.state : ''}- ${business.city ? business.city : ''} - ${business.address}`,
            mobile: business.mobile,
            nameActive: values.businessNameActive,
            addresActive: values.addressActive,
            telephoneActive: values.telephoneActive,
            phone: business.phone,
        };
        const personData = {
            name: data?.Person?.nickName,
            address: `${data?.Person?.state ? data?.Person?.state + '-' : ''}${data?.Person?.city ? data?.Person?.city + '-' : ''} ${data?.Person?.address ? data?.Person?.address : ''}`,
            mobile: data?.Person?.mobile,
            phone: data?.Person?.phone,
            nameActive: values.cutomerBusinessNameActive,
            addresActive: values.customerAddressActive,
            telephoneActive: values.customerTelephoneActive,

        };
        const sellerData = factorType === "sale" ? businessData : personData
        const buyerData = factorType === "sale" ? personData : businessData
        const BuyComp = () => {
            if (customerTelephoneActive || customerAddressActive || cutomerBusinessNameActive || customerMobile)
                return <div className="w-[50%] flex border-l   border-black">
                    <div className="rotate-1 mr-1 [writing-mode:vertical-lr] border-l  border-black justify-center flex font-bold text-black">خریدار</div>
                    <div className="w-full">
                        {cutomerBusinessNameActive && <div className="flex-row flex items-center">
                            <Typography
                                variant="body2"
                                fontWeight="bold"
                                color={generateRgb(invoiceHeaderColor)}
                                fontSize={invoiceHeaderSize}
                                className="text-nowrap"
                            >
                                {cutomerBusinessName}: &nbsp;
                            </Typography>
                            <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                {buyerData.name}
                            </Typography>
                        </div>
                        }
                        {customerAddressActive && (
                            <div className="flex-row flex border-t items-center  border-black">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                        className="text-nowrap"
                                    >
                                        {customerAddress} : &nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {buyerData?.address ? buyerData?.address : ''}
                                    </Typography>
                                </DetailsTextItem>
                            </div>
                        )}
                        {customerTelephoneActive && (
                            <div className="flex-row flex border-t items-center border-black">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                    >
                                        {customerTelephone}:&nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {buyerData.phone}
                                    </Typography>
                                </DetailsTextItem>

                            </div>
                        )}
                        {customerMobile && (
                            <div className="border-t border-black">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                    >
                                        همراه:&nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {buyerData.mobile}
                                    </Typography>
                                </DetailsTextItem>

                            </div>
                        )}
                    </div>
                </div>


            return <></>
        }
        const SellComp = () => {
            if (businessNameActive || addressActive || telephoneActive || mobile)
                return <div className="w-[50%] flex border-l   border-black">
                    <div className="rotate-1 [writing-mode:vertical-lr] border-l border-black justify-center flex font-bold text-black px-[3px]">فروشنده</div>
                    <div className="w-full">
                        {businessNameActive && <div className="flex items-center">
                            <Typography
                                variant="body2"
                                fontWeight="bold"
                                color={generateRgb(invoiceHeaderColor)}
                                fontSize={invoiceHeaderSize}
                                className="text-nowrap"
                            >
                                {businessName}: &nbsp;
                            </Typography>
                            <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                {sellerData.name}
                            </Typography>
                        </div>
                        }
                        {addressActive && (
                            <div className="border-t border-black items-center">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                        className="text-nowrap"
                                    >
                                        {address}: &nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {sellerData.address}
                                    </Typography>
                                </DetailsTextItem>
                            </div>
                        )}
                        {telephoneActive && (
                            <div className="border-t border-black">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                    >
                                        {telephone}:&nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {sellerData.phone}
                                    </Typography>
                                </DetailsTextItem>

                            </div>
                        )}
                        {mobile && (
                            <div className="border-t border-black">
                                <DetailsTextItem>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        color={generateRgb(invoiceHeaderColor)}
                                        fontSize={invoiceHeaderSize}
                                    >
                                        همراه:&nbsp;
                                    </Typography>
                                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                                        {sellerData.mobile}
                                    </Typography>
                                </DetailsTextItem>

                            </div>
                        )}
                    </div>
                </div>
            return <></>
        }

        const factorTitle = () => {
            // return data?.title;
            let title;
            if (data?.status === "پیش نویس") {
                title = "پیش فاکتور";
            } else {
                switch (data?.type) {
                    case "buy":
                        title = "فاکتور خرید";
                        break;
                    case "buyReturn":
                        title = "فاکتور برگشت از خرید";
                        break;
                    case "sale":
                        title = "فاکتور فروش";
                        break;
                    case "saleReturn":
                        title = "فاکتور برگشت از فروش";
                        break;
                    case "waste":
                        title = "فاکتور ضایعات";
                        break;
                }
            }
            return title;
        };
        return (
            <Container
                /* @ts-ignore */
                ref={ref}
                className="flex flex-col bg-white w-full h-full relative p-4">
                <div >
                    <table className="w-full text-sm rtl:text-right text-gray-500 text-right">
                        <thead>
                            <tr >
                                <td colSpan={5} className="border border-black">
                                    <>
                                        <div className="flex justify-between">
                                            <Logo src={logo || DefaultPrintLogo} />
                                            <Typography variant="h5" className="text-nowrap" color={generateRgb(invoiceHeaderColor)} fontWeight="bold">
                                                {factorTitle()}
                                            </Typography>
                                            <div className="flex flex-col gap-1">
                                                {showAccountingCode && (
                                                    <DetailsTextItem className="justify-between">
                                                        <Typography
                                                            variant="body2"
                                                            color={generateRgb(invoiceHeaderColor)}
                                                            fontSize={invoiceHeaderSize}
                                                            fontWeight="bold"
                                                            className="text-nowrap "
                                                        >
                                                            شماره فاکتور:&nbsp;
                                                        </Typography>
                                                        <Typography className="flex item-end" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="h6">
                                                            {data?.accountingCode}
                                                        </Typography>
                                                    </DetailsTextItem>
                                                )}
                                                {showDate && (
                                                    <DetailsTextItem >
                                                        <Typography
                                                            variant="body2"
                                                            color={generateRgb(invoiceHeaderColor)}
                                                            fontSize={invoiceHeaderSize}
                                                            fontWeight="bold"
                                                            className="whitespace-nowrap flex justify-center place-content-center items-center"
                                                        >
                                                            {showDueDate ? "تاریخ صدور" : "تاریخ"}:&nbsp;
                                                        </Typography>
                                                        <div className="flex flex-col justify-center place-content-center items-end">
                                                            <Typography
                                                                color={generateRgb(invoiceBodyColor)}
                                                                fontSize={invoiceBodySize}
                                                                variant="body2"
                                                                style={{ direction: "ltr" }}
                                                                className={`${showTime ? 'border-b border-black' : ''}`}
                                                            >
                                                                {data?.date}
                                                            </Typography>
                                                            {showTime && (
                                                                <>

                                                                    <Typography
                                                                        color={generateRgb(invoiceBodyColor)}
                                                                        fontSize={invoiceBodySize}
                                                                        variant="body2"
                                                                        style={{ direction: "ltr" }}

                                                                    >
                                                                        {data?.time}
                                                                    </Typography>
                                                                </>
                                                            )

                                                            }

                                                        </div>

                                                    </DetailsTextItem>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex border-t border-black">
                                            <SellComp />
                                            <BuyComp />

                                        </div>
                                    </>

                                </td>



                            </tr>

                            <tr className={`text-[${invoiceHeaderSize}px] font-bold border-black`}>
                                <th className=" text-black  bg-gray-50 px-1 border-b border-black py-1 border-l text-center font-bold rotate-1 [writing-mode:vertical-lr]  border-r-2">
                                    ردیف
                                </th>
                                <th className="px-2 border-b py-1 border-l  border-black  text-black  bg-gray-50 text-center font-bold  w-[49.4%] ">
                                    شرح کالا
                                </th>
                                <th className="px-2 border-b py-1 border-l border-black text-black  bg-gray-50 font-bold text-center">
                                    مقدار
                                </th>
                                <th className="px-2 border-b py-1 border-l border-black text-black  bg-gray-50 font-bold text-center">
                                    قیمت واحد
                                </th>
                                <th className="px-2 border-b py-1 border-l border-black  text-black  bg-gray-50 font-bold text-center">
                                    قیمت کل
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.Factor_Items.map((row: any, key: number) => {
                                return (
                                    <tr key={key} className={`odd:bg-white even:bg-gray-50 border-black border-b text-black text-wrap text-[${invoiceBodySize}px]`}>
                                        <td className=" px-1 py-1 border-black border-l text-wrap w-5 border-r">
                                            {key + 1}
                                        </td>
                                        <td className="px-2 py-1 border-black border-l text-wrap  ">
                                            {row?.Product?.title}
                                        </td>
                                        <td className="px-2 py-1 border-black border-l text-wrap  ">
                                            <div className="flex justify-between">
                                                <span className="">{row.quantity}</span>
                                                <span className=" ">{row.unit}</span>
                                            </div>
                                        </td>
                                        <td className="px-2 py-2 border-black border-l text-wrap  ">
                                            {formatPrice(row.price)} {row?.currency?.en_title}
                                        </td>
                                        <td className="px-2 py-2 border-black border-l text-wrap  ">
                                            {formatPrice(row.totalOneProduct)}
                                            {row?.currency?.en_title}
                                        </td>
                                    </tr>
                                )
                            })}

                            <tr className="border border-black">
                                <td colSpan={5}>
                                    <div className="flex">
                                        <div className="flex-col justify-start w-1/2 border-black border-b">
                                            {data?.totalPrice ? (<>
                                                <div className="flex flex-wrap flex-row">
                                                    <Typography
                                                        color={generateRgb(invoiceHeaderColor)}
                                                        fontSize={invoiceHeaderSize}
                                                        fontWeight="bold"
                                                        variant="body2"
                                                        className="text-nowrap"
                                                    >
                                                        جمع کل به حروف :&nbsp;
                                                    </Typography>

                                                    <Typography className="text-wrap" color={generateRgb(invoiceBodyColor)} variant="caption">{Num2persian(data?.totalPrice)} {data?.Currency?.fa_title}</Typography>
                                                </div>

                                            </>
                                            ) : null}

                                        </div>
                                        <div className="w-1/2 flex-col border-r border-b border-black justify-start">
                                            <div className="flex flex-nowrap flex-row  border-black border-b">
                                                <Typography fontWeight="bold" variant="body2" color={generateRgb(invoiceHeaderColor)} fontSize={invoiceHeaderSize}>
                                                    مبلغ کل:&nbsp;
                                                </Typography>
                                                <PriceComponent price={formatPrice(data?.total)} currency={data?.Currency?.en_title} />
                                            </div>
                                            {activeSumQuantity && <div className="flex flex-nowrap flex-row  border-black border-b">
                                                <Typography
                                                    color={generateRgb(invoiceHeaderColor)}
                                                    fontSize={invoiceHeaderSize}
                                                    fontWeight="bold"
                                                    variant="body2"
                                                    className="text-wrap"
                                                >
                                                    جمع مقدار:&nbsp;
                                                </Typography>

                                                <Typography variant="body2">
                                                    {data?.totalQuantity || 0} {data?.unit}
                                                </Typography>
                                            </div>}
                                            {activeSumDiscount && <div className="flex flex-nowrap flex-row border-black border-b">
                                                <Typography
                                                    color={generateRgb(invoiceHeaderColor)}
                                                    fontSize={invoiceHeaderSize}
                                                    fontWeight="bold"
                                                    variant="body2"
                                                    className="text-wrap"
                                                >
                                                    جمع تخفیف:&nbsp;
                                                </Typography>

                                                <PriceComponent price={formatPrice(data?.totalDiscount)} currency={data?.Currency?.en_title} />
                                            </div>}
                                            {activeSumTax && <div className="flex flex-nowrap border-black flex-row border-b">
                                                <Typography
                                                    color={generateRgb(invoiceHeaderColor)}
                                                    fontSize={invoiceHeaderSize}
                                                    fontWeight="bold"
                                                    variant="body2"
                                                    className="text-wrap"
                                                >
                                                    جمع مالیات:&nbsp;
                                                </Typography>

                                                <PriceComponent price={formatPrice(data?.totalTax)} currency={data?.Currency?.en_title} />
                                            </div>}
                                            <div className="flex flex-nowrap flex-row  border-black">
                                                <Typography
                                                    color={generateRgb(invoiceHeaderColor)}
                                                    fontSize={invoiceHeaderSize}
                                                    fontWeight="bold"
                                                    variant="body2"
                                                    className="text-wrap"
                                                >
                                                    جمع کل:&nbsp;
                                                </Typography>

                                                <PriceComponent price={formatPrice(data?.totalPrice)} currency={data?.Currency?.en_title} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" flex flex-wrap  border-black">
                                        <Typography
                                            color={generateRgb(invoiceHeaderColor)}
                                            fontSize={invoiceHeaderSize}
                                            fontWeight="bold"
                                            variant="body2"
                                            className="text-wrap"
                                        >
                                            توضیحات:&nbsp;
                                        </Typography>
                                        <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} style={{ whiteSpace: 'pre-line' }}>
                                            {description}
                                        </Typography>
                                    </div>
                                    {showSellerSign ? (
                                        <SignContainer className="border-t border-black">
                                            <SignComponent className=" border-black border-l">
                                                <Typography sx={{ height: "50%", paddingTop: "10px" }}>
                                                    مهر امضا {["sale", "saleReturn"].includes(factorType) ? "فروشنده" : "خریدار"}
                                                </Typography>
                                                {/* @ts-ignore */}
                                                <SignImageContainer backgroundImage={sign} />
                                            </SignComponent>
                                            {showCustomerSign ? (
                                                <SignComponent className="border-black">
                                                    <Typography sx={{ height: "50%", paddingTop: "10px" }}>
                                                        مهر امضا {["sale", "saleReturn"].includes(factorType) ? "خریدار" : "فروشنده"}
                                                    </Typography>
                                                    {/* @ts-ignore */}
                                                    <SignImageContainer />
                                                </SignComponent>
                                            ) : (
                                                <div></div>
                                            )}

                                        </SignContainer>
                                    ) : (
                                        <></>
                                    )}
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div>


            </Container >
        );
    })

export default FactorPatternTemplate;